import { is_subassembly, subassembly_name_of } from "../utils/subassemblies.js";

export function zones_from_viewer_bom(bom, design_name = false) {

    // Filter subassembly if needed
    if (design_name) bom = bom.filter(p => p.subassembly_name == design_name)

    // Now go with zones
    let zones = bom
        // Map parts to zones
        .map(part => part.zone)
        // Remove undefineds &  99 (megawrapper undefined)
        .filter(z => z != undefined && z != 99)
    zones = zones
        // Remove duplicates
        .filter((v, i) => zones.indexOf(v) === i)
        // Order
        .sort((a, b) => a - b)
    return zones
}


// The rows of a viewer BOM that are this design's own parts. A subassembly's
// BOM is its panel's whole one: its rows are those named after it. A panel's
// are those of no subassembly ("-" included), or named after the panel itself,
// as the backend's `get_parts` keeps them (wrappers/base/wrapper.py).
export function design_rows_of_viewer_bom(bom, design) {
    if (!design) return bom
    if (is_subassembly(design))
        return bom.filter(p => subassembly_name_of(p) == design.name)
    return bom.filter(p => {
        const name = subassembly_name_of(p)
        return !name || name == design.name
    })
}
